import { Icon } from "@iconify/react";
import React from "react";
import { useHistory } from "react-router-dom";

const OrderFailed = () => {
  const history = useHistory();

  const backtohome = () => {
    history.push(`/dashboard/`);
  };

  return (
    <div className="payment_pop" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div className="popping" style={{
        textAlign: "center", background: '#fff',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        padding: '30px',
        borderRadius: ' 10px'
      }}>
        <div className="mb-5 w-full flex flex-col items-center justify-center">
          <div className="mb-5">
            <Icon icon="ooui:error" style={{ fontSize: "6em", color: "red" }} />
          </div>
          <h1 className="mb-5 !font-semibold">Order Failed!</h1>
          <h4 className="!text-description !text-xl">We failed to save order, please call customer support on our site</h4>
        </div>
        <button
          className="sign_btn"
          style={{ fontSize: "20px", background: "red" }}
          onClick={backtohome}
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
};

export default OrderFailed;
